import type { FC, ReactNode } from 'react';
import { Box, Tooltip, Typography } from '@mui/material';

import ComparisonPill from 'src/components/dashboard/DashboardPage/components/ComparisonPill/ComparisonPill';

interface WidgetLegendProps {
  labelValuePairs: {
    label: ReactNode;
    value: ReactNode;
    comparisonValue?: string;
    key: string;
    colorOverride?: string;
    toolTip?: ReactNode;
  }[];
}

const WidgetLegend: FC<WidgetLegendProps> = ({ labelValuePairs }) => (
  <Box display="flex" flexDirection="column" gap={1} width="100%">
    {labelValuePairs.map(
      ({ label, value, colorOverride, key, toolTip, comparisonValue }) => (
        <Box display="flex" alignItems="center" gap={2} key={key}>
          <Typography
            variant="body3"
            gap={0.5}
            display="flex"
            justifyContent="flex-end"
            width="50%"
            fontWeight={600}
            color={colorOverride ?? 'textPrimary'}
            lineHeight={1.75}
          >
            {label}
          </Typography>
          <Typography
            variant="body3"
            width="50%"
            fontWeight={600}
            color={colorOverride ?? 'textPrimary'}
            position="relative"
          >
            <Tooltip key={key} title={toolTip}>
              <span>{value}</span>
            </Tooltip>
            {comparisonValue && (
              <ComparisonPill
                value={comparisonValue}
                component="span"
                sx={{ display: 'inline-block', ml: '4px' }}
              />
            )}
          </Typography>
        </Box>
      ),
    )}
  </Box>
);

export default WidgetLegend;
